import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showLoginModal } from "../../store/slices/loginModalSlice";
import { showCartModal } from "../../store/slices/cartModalSlice";
import {
  faUnlock,
  faCartShopping,
  faUser,
  faUserGear,
  faSignInAlt,
  faRightToBracket,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import "./header.css";
import axiosInstance from "../../apis/config";
import PopoverContent from "./popover";
import { showToast } from "../../store/slices/toastSlice";
import { FiFacebook } from "react-icons/fi";
import {
  FaInstagram,
  FaTiktok,
  FaHeadphonesAlt,
  FaSearch,
} from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { IoHome, IoClose } from "react-icons/io5";
import { IoMdMenu } from "react-icons/io";
import companyData from "../../companyData";

const Header2 = ({ isMediumScreen, cart }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [decodedToken, setDecodedToken] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const location = useLocation();
  const cartOpen = useSelector((state) => state.cartModal.show);
  const goToSomewhere = (e, link) => {
    e.stopPropagation();
    navigate(link);
    setActive("");
    if (location.pathname.startsWith("/shop")) {
      window.location.reload();
    }
  };
  const openMenu = (e) => {
    e.stopPropagation();
    setActive("active");
  };
  const closeMenu = (e) => {
    e.stopPropagation();
    setActive("");
  };
  const logOut = (e) => {
    e.stopPropagation();
    if (isLoggedIn) {
      localStorage.removeItem("userToken");
      navigate("/");
      window.location.reload();
      dispatch(showToast("See you when We see you!"));
    } else {
      dispatch(showLoginModal(true));
    }
    setActive("");
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        setIsLoggedIn(false);
        setDecodedToken(null);
        localStorage.removeItem("userToken");
      } else {
        setIsLoggedIn(true);
        setDecodedToken(decoded);
      }
    } else {
      setIsLoggedIn(false);
      setDecodedToken(null);
    }
  }, [cart]);

  //head functionality
  useEffect(() => {
    // Function to handle submenu toggle
    const handleSubMenuToggle = (event) => {
      const parentMenuCategory = event.target.closest(".menu-category");
      const submenu = parentMenuCategory.querySelector(
        ".submenu-category-list",
      );
      submenu.classList.toggle("active");

      // Toggle the icon
      const icon = event.target;
      if (submenu.classList.contains("active")) {
        icon.setAttribute("name", "remove-outline");
      } else {
        icon.setAttribute("name", "add-outline");
      }
    };

    // Add event listener to all add-icons
    const addIcons = document.querySelectorAll(".add-icon");
    addIcons.forEach((icon) => {
      icon.addEventListener("click", handleSubMenuToggle);
    });

    // Cleanup: Remove event listeners
    return () => {
      addIcons.forEach((icon) => {
        icon.removeEventListener("click", handleSubMenuToggle);
      });
    };
  }, []);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        event.target.closest("[data-mobile-menu]") === null &&
        active !== ""
      ) {
        setActive("");
      }
    };
    document.body.addEventListener("click", handleOutsideClick);
    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [active]);

  const [query, setQuery] = useState("");

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      search();
    }
  };

  const search = () => {
    if (query.trim()) {
      const url = `/search?page=1&query=${encodeURIComponent(query.trim())}`;
      navigate(url);
    }
  };
  function handelLogout() {
    if (isLoggedIn) {
      localStorage.removeItem("userToken");
      navigate("/");
      window.location.reload();
      dispatch(showToast("See you when We see you!"));
    } else {
      dispatch(showLoginModal(true));
    }
  }

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`/categories`, {})
      .then((res) => {
        axiosInstance
          .get(`/brands`, {})
          .then((res) => {
            setBrands(res.data.allData);
          })
          .catch((err) => {
            console.log(err);
          });
        const shuffledCategories = res.data.data.sort(
          () => Math.random() - 0.5,
        );
        const randomFourCategories = shuffledCategories.slice(0, 4);
        setCategories(randomFourCategories);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  //first cat
  const category = categories[0];
  const filteredBrands = category
    ? brands.filter(
        (brand) => brand.category.toLowerCase() === category.name.toLowerCase(),
      )
    : [];
  const shuffledFilteredBrands = filteredBrands.sort(() => Math.random() - 0.5);
  const randomFiveBrands = shuffledFilteredBrands.slice(0, 5);

  // second cat
  const category2 = categories[1];
  const filteredBrands2 = category2
    ? brands.filter((brand) => brand.category === category2.name)
    : [];
  const shuffledFilteredBrands2 = filteredBrands2.sort(
    () => Math.random() - 0.5,
  );
  const randomFiveBrands2 = shuffledFilteredBrands2.slice(0, 5);

  //third cat
  const category3 = categories[2];
  const filteredBrands3 = category3
    ? brands.filter((brand) => brand.category === category3.name)
    : [];
  const shuffledFilteredBrands3 = filteredBrands3.sort(
    () => Math.random() - 0.5,
  );
  const randomFiveBrands3 = shuffledFilteredBrands3.slice(0, 5);

  //fourth cat
  const category4 = categories[3];
  const filteredBrands4 = category4
    ? brands.filter((brand) => brand.category === category4.name)
    : [];
  const shuffledFilteredBrands4 = filteredBrands4.sort(
    () => Math.random() - 0.5,
  );
  const randomFiveBrands4 = shuffledFilteredBrands4.slice(0, 5);

  const [showPopover, setShowPopover] = useState(false);
  const [showPopover2, setShowPopover2] = useState(false);

  const targetRef = useRef(null);
  const targetRef2 = useRef(null);

  useEffect(() => {
    if (cart.items?.length === 1 && !cartOpen) {
      setShowPopover2(true);
      setShowPopover(true);
      if (isMediumScreen === false) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }, [cart, isMediumScreen, cartOpen]);
  useEffect(() => {
    let timer;
    if (showPopover) {
      timer = setTimeout(() => {
        setShowPopover(false);
      }, 5000);
    }
    if (showPopover2) {
      timer = setTimeout(() => {
        setShowPopover2(false);
      }, 5000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [showPopover, showPopover2]);

  return (
    <header itemScope itemType="http://schema.org/LocalBusiness">
      {/* Structured Data for Local SEO */}
      <div
        itemScope
        itemProp="address"
        itemType="http://schema.org/PostalAddress"
        style={{ display: "none" }}
      >
        <span itemProp="streetAddress">
          Nakuru Wilmur house room 11, Kenyatta avenue,Next To Family Bank
        </span>
        <span itemProp="addressLocality">Nakuru</span>
        <span itemProp="addressRegion">Kenya</span>
        <span itemProp="addressCountry">KE</span>
      </div>
      <meta itemProp="name" content={companyData.name} />
      <meta
        itemProp="description"
        content="Leading provider of CCTV solutions, biometric systems, security solutions and IT services in Nakuru, Kenya"
      />
      <meta itemProp="telephone" content={companyData.phone} />
      <meta itemProp="openingHours" content="Mo-Sa 08:00-17:00" />
      <meta itemProp="priceRange" content="$$" />

      <div class="header-top">
        <div class="container">
          <ul className="header-social-container">
            <li>
              <a
                href={`${companyData.facebook}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Facebook page"
              >
                <FiFacebook />
              </a>
            </li>
            <li>
              <a
                href={`${companyData.tiktok}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our TikTok channel"
              >
                <FaTiktok style={{ fontSize: "15px" }} />
              </a>
            </li>
            <li>
              <a
                href={`${companyData.instagram}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram profile"
              >
                <FaInstagram />
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/+254${companyData.whatsapp}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
              >
                <BsWhatsapp />
              </a>
            </li>
          </ul>
          {/* desktop */}
          <div>
            <div className="header-alert-news">
              <b>
                Welcome to {companyData.name} - CCTV & Security Solutions Expert
                in Nakuru, Kenya
              </b>
            </div>
          </div>

          <div class="header-top-actions">
            <div className="" style={{ display: "flex", color: "#514c4c" }}>
              <div style={{ marginRight: "6px" }}>
                <FaHeadphonesAlt />
              </div>
              <div style={{ marginTop: "2px" }} itemProp="telephone">
                {companyData.phonespace}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* mobile */}
      <div class="header-main">
        <div
          className="header-alert-news-two"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            backgroundColor: "#ff5722",
            color: "#ffffff",
            padding: "10px",
            borderRadius: "4px",
            fontSize: "16px",
          }}
        >
          <p style={{ margin: 0 }}>Welcome to {companyData.name}</p>
        </div>
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            marginTop: "5px",
          }}
        >
          Call Us: <span itemProp="telephone">{companyData.phonespace}</span>
        </p>
        <div class="container">
          <Link to="/" class="header-logo logo-filter" aria-label="Home">
            <img
              src={companyData.logo}
              alt={`${companyData.name} - CCTV & Security Solutions Provider in Nakuru, Kenya`}
              width="100"
              height="auto"
              itemProp="logo"
            />
          </Link>

          <div class="header-search-container">
            <input
              type="search"
              name="search"
              class="search-field"
              placeholder="Search CCTV, biometric systems, alarms..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleSearch}
              aria-label="Search security products"
            />

            <button
              class="search-btn"
              onClick={search}
              aria-label="Submit search"
            >
              <FaSearch color="#838080" />
            </button>
          </div>

          <div class="header-user-actions">
            <button class="action-btn">
              {isLoggedIn ? (
                <Link
                  className="btn p-0 color-main-gray fs-5 hover-color-yellow"
                  to={
                    cart?.role === "user"
                      ? `/account/${decodedToken.id}`
                      : "/dashboard"
                  }
                  aria-label={
                    cart?.role === "user" ? "My Account" : "Admin Dashboard"
                  }
                >
                  <FontAwesomeIcon
                    icon={cart?.role === "user" ? faUser : faUserGear}
                    style={{ fontSize: "25px" }}
                  />
                  <span className="visually-hidden">
                    {cart?.role === "user" ? "account" : "dashboard"}
                  </span>
                </Link>
              ) : (
                <button
                  className="btn p-0 color-main-gray hover-color-yellow"
                  onClick={() => dispatch(showLoginModal(true))}
                  aria-label="Login or Register"
                >
                  <FontAwesomeIcon
                    icon={faUnlock}
                    style={{ fontSize: "25px" }}
                  />{" "}
                </button>
              )}
            </button>

            <button
              class="action-btn"
              onClick={handelLogout}
              aria-label={isLoggedIn ? "Logout" : "Login"}
            >
              <FontAwesomeIcon
                icon={faSignInAlt}
                style={{ fontSize: "25px" }}
              />
            </button>
            {/* cart  */}
            {!(
              cart.role &&
              (cart.role === "admin" || cart.role === "agent")
            ) && (
              <button
                type="button"
                className="cart-btn btn p-0 fs-5 hover-color-yellow position-relative"
                ref={targetRef}
                onClick={() =>
                  decodedToken
                    ? dispatch(showCartModal(true))
                    : dispatch(showLoginModal(true))
                }
                aria-label="View shopping cart"
              >
                <FontAwesomeIcon
                  icon={faCartShopping}
                  style={{ fontSize: "25px" }}
                />
                <span className="visually-hidden">cart</span>
                <span className="position-absolute bg-yellow top-0 start-0 translate-middle badge rounded-pill">
                  {cart.items
                    ? cart.items?.length > 99
                      ? "99+"
                      : cart.items?.length
                    : 0}
                  <span className="visually-hidden">items in cart</span>
                </span>
              </button>
            )}
          </div>
          <PopoverContent
            show={showPopover}
            targetRef={targetRef}
            message={"Your Cart is here 🥰"}
            place={"left"}
            onClose={() => setShowPopover(false)}
          />
          <PopoverContent
            show={showPopover2}
            targetRef={targetRef2}
            message={"Your Cart is here 🥰"}
            place={"top"}
            onClose={() => setShowPopover2(false)}
          />
        </div>
      </div>
      <nav class="desktop-navigation-menu" aria-label="Main navigation">
        <div class="container">
          <ul class="desktop-menu-category-list">
            <li class="menu-category">
              <Link to="/" class="menu-title" title="Home">
                Home
              </Link>
            </li>

            <li
              class="menu-category"
              onClick={() => {
                window.location.reload();
              }}
            >
              <Link
                to="/shop"
                class="menu-title"
                title="Security Product Categories"
              >
                Categories
              </Link>

              <div class="dropdown-panel">
                <ul class="dropdown-panel-list">
                  <li class="menu-title text-capitalize">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[0]?._id}&sort=0&price=0`}
                      title={`Browse ${categories[0]?.name} in Nakuru`}
                    >
                      {categories[0]?.name}
                    </Link>
                  </li>
                  {randomFiveBrands.length === 1 ? (
                    <>
                      {randomFiveBrands.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands.length === 2 ? (
                    <>
                      {randomFiveBrands.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands.length === 3 ? (
                    <>
                      {randomFiveBrands.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands.length === 4 ? (
                    <>
                      {randomFiveBrands.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : (
                    randomFiveBrands.map((brand) => (
                      <li key={brand._id} className="panel-list-item">
                        <Link
                          to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                          title={`${brand.name} security products`}
                        >
                          {brand.name}
                        </Link>
                      </li>
                    ))
                  )}
                  <li class="panel-list-item">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[0]?._id}&sort=0&price=0`}
                      title={`${categories[0]?.name} in Nakuru`}
                    >
                      <img
                        src={`${categories[0]?.image[0]?.url}`}
                        alt={`${categories[0]?.name} security systems in Nakuru`}
                        style={{
                          maxHeight: "150px",
                          maxWidth: "150px",
                          border: "1px solid #ddd",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      />
                    </Link>
                  </li>
                </ul>
                <ul class="dropdown-panel-list">
                  <li class="menu-title text-capitalize">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[1]?._id}&sort=0&price=0`}
                      title={`Browse ${categories[1]?.name} in Nakuru`}
                    >
                      {categories[1]?.name}
                    </Link>
                  </li>

                  {randomFiveBrands2.length === 1 ? (
                    <>
                      {randomFiveBrands2.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands2.length === 2 ? (
                    <>
                      {randomFiveBrands2.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands2.length === 3 ? (
                    <>
                      {randomFiveBrands2.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands2.length === 4 ? (
                    <>
                      {randomFiveBrands2.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : (
                    randomFiveBrands2.map((brand) => (
                      <li key={brand._id} className="panel-list-item">
                        <Link
                          to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                          title={`${brand.name} security products`}
                        >
                          {brand.name}
                        </Link>
                      </li>
                    ))
                  )}
                  <li class="panel-list-item">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[1]?._id}&sort=0&price=0`}
                      title={`${categories[1]?.name} in Nakuru`}
                    >
                      <img
                        src={`${categories[1]?.image[0]?.url}`}
                        alt={`${categories[1]?.name} security solutions in Nakuru`}
                        style={{
                          maxHeight: "150px",
                          maxWidth: "150px",
                          border: "1px solid #ddd",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      />
                    </Link>
                  </li>
                </ul>
                <ul class="dropdown-panel-list">
                  <li class="menu-title text-capitalize">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[2]?._id}&sort=0&price=0`}
                      title={`Browse ${categories[2]?.name} in Nakuru`}
                    >
                      {categories[2]?.name}
                    </Link>
                  </li>

                  {randomFiveBrands3.length === 1 ? (
                    <>
                      {randomFiveBrands3.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands3.length === 2 ? (
                    <>
                      {randomFiveBrands3.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands3.length === 3 ? (
                    <>
                      {randomFiveBrands3.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands3.length === 4 ? (
                    <>
                      {randomFiveBrands3.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : (
                    randomFiveBrands3.map((brand) => (
                      <li key={brand._id} className="panel-list-item">
                        <Link
                          to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                          title={`${brand.name} security products`}
                        >
                          {brand.name}
                        </Link>
                      </li>
                    ))
                  )}

                  <li class="panel-list-item">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[2]?._id}&sort=0&price=0`}
                      title={`${categories[2]?.name} in Nakuru`}
                    >
                      <img
                        src={`${categories[2]?.image[0]?.url}`}
                        alt={`${categories[2]?.name} security equipment in Nakuru`}
                        style={{
                          maxHeight: "150px",
                          maxWidth: "150px",
                          border: "1px solid #ddd",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      />
                    </Link>
                  </li>
                </ul>
                <ul class="dropdown-panel-list">
                  <li class="menu-title text-capitalize">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[3]?._id}&sort=0&price=0`}
                      title={`Browse ${categories[3]?.name} in Nakuru`}
                    >
                      {categories[3]?.name}
                    </Link>
                  </li>

                  {randomFiveBrands4.length === 1 ? (
                    <>
                      {randomFiveBrands4.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands4.length === 2 ? (
                    <>
                      {randomFiveBrands4.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands4.length === 3 ? (
                    <>
                      {randomFiveBrands4.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : randomFiveBrands4.length === 4 ? (
                    <>
                      {randomFiveBrands4.map((brand) => (
                        <li key={brand._id} className="panel-list-item">
                          <Link
                            to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                            title={`${brand.name} security products`}
                          >
                            {brand.name}
                          </Link>
                        </li>
                      ))}
                      <li className="panel-list-item">
                        <Link to={`/shop`}>
                          {" "}
                          <span class="placeholder col-6 rounded"></span>{" "}
                        </Link>
                      </li>
                    </>
                  ) : (
                    randomFiveBrands4.map((brand) => (
                      <li key={brand._id} className="panel-list-item">
                        <Link
                          to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                          title={`${brand.name} security products`}
                        >
                          {brand.name}
                        </Link>
                      </li>
                    ))
                  )}
                  <li class="panel-list-item">
                    <Link
                      to={`/shop?page=1&brand=all&category=${categories[3]?._id}&sort=0&price=0`}
                      title={`${categories[3]?.name} in Nakuru`}
                    >
                      <img
                        src={`${categories[3]?.image[0]?.url}`}
                        alt={`${categories[3]?.name} security products in Nakuru`}
                        style={{
                          maxHeight: "150px",
                          maxWidth: "150px",
                          border: "1px solid #ddd",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            <li
              class="menu-category"
              onClick={() => {
                window.location.reload();
              }}
            >
              <Link
                to={`/shop?page=1&brand=all&category=${categories[0]?._id}&sort=0&price=0`}
                class="menu-title"
                title={`${categories[0]?.name} Security Systems`}
              >
                {loading ? <p>coming</p> : categories[0]?.name}
              </Link>

              <ul class="dropdown-list">
                {randomFiveBrands.map((brand) => (
                  <li key={brand._id} class="dropdown-item">
                    <Link
                      to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                      title={`${brand.name} products`}
                    >
                      {brand.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li
              class="menu-category"
              onClick={() => {
                window.location.reload();
              }}
            >
              <Link
                to={`/shop?page=1&brand=all&category=${categories[1]?._id}&sort=0&price=0`}
                class="menu-title"
                title={`${categories[1]?.name} Security Solutions`}
              >
                {loading ? <p>coming</p> : categories[1]?.name}
              </Link>

              <ul class="dropdown-list">
                {randomFiveBrands2.map((brand) => (
                  <li key={brand._id} class="dropdown-item">
                    <Link
                      to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                      title={`${brand.name} products`}
                    >
                      {brand.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li
              class="menu-category"
              onClick={() => {
                window.location.reload();
              }}
            >
              <Link
                to={`/shop?page=1&brand=all&category=${categories[2]?._id}&sort=0&price=0`}
                class="menu-title"
                title={`${categories[2]?.name} Security Equipment`}
              >
                {loading ? <p>Appearing</p> : categories[2]?.name}
              </Link>

              <ul class="dropdown-list">
                {randomFiveBrands3.map((brand) => (
                  <li key={brand._id} class="dropdown-item">
                    <Link
                      to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                      title={`${brand.name} products`}
                    >
                      {brand.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li
              class="menu-category"
              onClick={() => {
                window.location.reload();
              }}
            >
              <Link
                to={`/shop?page=1&brand=all&category=${categories[3]?._id}&sort=0&price=0`}
                class="menu-title"
                title={`${categories[3]?.name} Security Products`}
              >
                {loading ? <p>showing</p> : categories[3]?.name}
              </Link>

              <ul class="dropdown-list">
                {randomFiveBrands4.map((brand) => (
                  <li key={brand._id} class="dropdown-item">
                    <Link
                      to={`/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`}
                      title={`${brand.name} products`}
                    >
                      {brand.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li class="menu-category">
              <Link
                to="/shop"
                class="menu-title"
                title="Security Products Shop"
              >
                Shop
              </Link>
            </li>
            <li class="menu-category">
              <Link to="/projects" class="menu-title" title="Projects">
                Projects
              </Link>
            </li>
            <li class="menu-category">
              <Link to="/contact" class="menu-title" title="Contact Us">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <div class="mobile-bottom-navigation">
        <button
          onClick={(e) => openMenu(e)}
          class="action-btn"
          data-mobile-menu-open-btn
          aria-label="Open menu"
        >
          <IoMdMenu />{" "}
        </button>
        {!(cart.role && (cart.role === "admin" || cart.role === "agent")) && (
          <div className=" text-center">
            <div>
              <button
                type="button"
                className="cart-btn btn lh-1 p-0 fs-5 hover-color-yellow position-relative"
                ref={targetRef2}
                onClick={() =>
                  cart.user_id
                    ? dispatch(showCartModal(true))
                    : dispatch(showLoginModal(true))
                }
                aria-label="View shopping cart"
              >
                <FontAwesomeIcon icon={faCartShopping} />
                <span className="visually-hidden">cart</span>
                <span className="position-absolute bg-yellow top-0 start-0 translate-middle badge rounded-pill">
                  {cart.items
                    ? cart.items?.length > 99
                      ? "99+"
                      : cart.items?.length
                    : 0}
                  <span className="visually-hidden">items in cart</span>
                </span>
              </button>
            </div>
          </div>
        )}
        <Link to="/">
          <button class="action-btn" aria-label="Go to home">
            <IoHome />{" "}
          </button>
        </Link>

        <div
          className={`${
            cart.role === "admin" || cart.role === "agent" ? "col-3" : ""
          } text-center`}
        >
          <div>
            <Link
              to="/search"
              className="btn lh-1 p-0 fs-5 color-main-gray hover-color-yellow"
              aria-label="Search products"
            >
              <FaSearch />
              <span className="visually-hidden">search</span>
            </Link>
          </div>
        </div>
        <div>
          {cart.user_id ? (
            <Link
              className="btn p-0 lh-1 color-main-gray fs-5 hover-color-yellow"
              to={`/account/${cart.user_id}`}
              aria-label="My account"
            >
              <FontAwesomeIcon icon={faUser} />
              <span className="visually-hidden">account</span>
            </Link>
          ) : cart.role === "admin" || cart.role === "agent" ? (
            <Link
              className="btn p-0 lh-1 color-main-gray fs-5 hover-color-yellow"
              to={`/dashboard`}
              aria-label="Admin dashboard"
            >
              <FontAwesomeIcon icon={faUserGear} />
              <span className="visually-hidden">dashboard</span>
            </Link>
          ) : (
            <button
              className="btn p-0 lh-1 fs-5 color-main-gray hover-color-yellow"
              onClick={() => dispatch(showLoginModal(true))}
              aria-label="Login or register"
            >
              <FontAwesomeIcon icon={faUser} />
              <span className="visually-hidden">login / register</span>
            </button>
          )}
        </div>
      </div>
      <nav
        className={`mobile-navigation-menu has-scrollbar ${active}`}
        data-mobile-menu
        aria-label="Mobile navigation"
      >
        <div class="menu-top">
          <h2 class="menu-title">Menu</h2>

          <button
            onClick={(e) => closeMenu(e)}
            class="menu-close-btn"
            data-mobile-menu-close-btn
            aria-label="Close menu"
          >
            <IoClose />{" "}
          </button>
        </div>

        <ul class="mobile-menu-category-list">
          <li class="menu-category">
            <button
              onClick={(e) => goToSomewhere(e, "/")}
              class="menu-title"
              aria-label="Home"
            >
              Home
            </button>
          </li>
          <li class="menu-category">
            <button
              onClick={(e) => goToSomewhere(e, "/shop")}
              class="menu-title"
              aria-label="Shop security products"
            >
              Shop
            </button>
          </li>
          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p class="menu-title">Categories</p>
              <div>
                <ion-icon name="add-outline" class="add-icon"></ion-icon>
                <ion-icon name="remove-outline" class="remove-icon"></ion-icon>
              </div>
            </button>

            <ul class="submenu-category-list" data-accordion>
              <li class="submenu-category">
                <button
                  onClick={(e) =>
                    goToSomewhere(
                      e,
                      `/shop?page=1&brand=all&category=${categories[0]?._id}&sort=0&price=0`,
                    )
                  }
                  class="submenu-title text-capitalize"
                  aria-label={`Browse ${categories[0]?.name}`}
                >
                  {categories[0]?.name}
                </button>
              </li>
              <li class="submenu-category">
                <button
                  onClick={(e) =>
                    goToSomewhere(
                      e,
                      `/shop?page=1&brand=all&category=${categories[1]?._id}&sort=0&price=0`,
                    )
                  }
                  class="submenu-title text-capitalize"
                  aria-label={`Browse ${categories[1]?.name}`}
                >
                  {categories[1]?.name}
                </button>
              </li>{" "}
              <li class="submenu-category">
                <button
                  onClick={(e) =>
                    goToSomewhere(
                      e,
                      `/shop?page=1&brand=all&category=${categories[2]?._id}&sort=0&price=0`,
                    )
                  }
                  class="submenu-title text-capitalize"
                  aria-label={`Browse ${categories[2]?.name}`}
                >
                  {categories[2]?.name}
                </button>
              </li>{" "}
              <li class="submenu-category">
                <button
                  onClick={(e) =>
                    goToSomewhere(
                      e,
                      `/shop?page=1&brand=all&category=${categories[3]?._id}&sort=0&price=0`,
                    )
                  }
                  class="submenu-title text-capitalize"
                  aria-label={`Browse ${categories[3]?.name}`}
                >
                  {categories[3]?.name}
                </button>
              </li>
            </ul>
          </li>
          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title text-capitalize"
                aria-label={`${categories[0]?.name} products`}
              >
                {categories[0]?.name}
              </p>

              <div>
                <ion-icon name="add-outline" class="add-icon"></ion-icon>
                <ion-icon name="remove-outline" class="remove-icon"></ion-icon>
              </div>
            </button>

            <ul class="submenu-category-list" data-accordion>
              {randomFiveBrands.map((brand) => (
                <li class="submenu-category">
                  <button
                    onClick={(e) =>
                      goToSomewhere(
                        e,
                        `/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`,
                      )
                    }
                    class="submenu-title text-capitalize"
                    aria-label={`Browse ${brand.name}`}
                  >
                    {brand.name}
                  </button>
                </li>
              ))}
            </ul>
          </li>

          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title text-capitalize"
                aria-label={`${categories[1]?.name} products`}
              >
                {categories[1]?.name}
              </p>

              <div>
                <ion-icon name="add-outline" class="add-icon"></ion-icon>
                <ion-icon name="remove-outline" class="remove-icon"></ion-icon>
              </div>
            </button>

            <ul class="submenu-category-list" data-accordion>
              {randomFiveBrands2.map((brand) => (
                <li class="submenu-category">
                  <button
                    onClick={(e) =>
                      goToSomewhere(
                        e,
                        `/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`,
                      )
                    }
                    class="submenu-title text-capitalize"
                    aria-label={`Browse ${brand.name}`}
                  >
                    {brand.name}
                  </button>
                </li>
              ))}
            </ul>
          </li>

          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title text-capitalize"
                aria-label={`${categories[2]?.name} products`}
              >
                {categories[2]?.name}
              </p>

              <div>
                <ion-icon name="add-outline" class="add-icon"></ion-icon>
                <ion-icon name="remove-outline" class="remove-icon"></ion-icon>
              </div>
            </button>

            <ul class="submenu-category-list" data-accordion>
              {randomFiveBrands3.map((brand) => (
                <li class="submenu-category">
                  <button
                    onClick={(e) =>
                      goToSomewhere(
                        e,
                        `/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`,
                      )
                    }
                    class="submenu-title text-capitalize"
                    aria-label={`Browse ${brand.name}`}
                  >
                    {brand.name}
                  </button>
                </li>
              ))}
            </ul>
          </li>

          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title text-capitalize"
                aria-label={`${categories[3]?.name} products`}
              >
                {categories[3]?.name}
              </p>

              <div>
                <ion-icon name="add-outline" class="add-icon"></ion-icon>
                <ion-icon name="remove-outline" class="remove-icon"></ion-icon>
              </div>
            </button>

            <ul class="submenu-category-list" data-accordion>
              {randomFiveBrands4.map((brand) => (
                <li class="submenu-category">
                  <button
                    onClick={(e) =>
                      goToSomewhere(
                        e,
                        `/shop?page=1&brand=${brand?._id}&category=all&sort=0&price=0`,
                      )
                    }
                    class="submenu-title text-capitalize"
                    aria-label={`Browse ${brand.name}`}
                  >
                    {brand.name}
                  </button>
                </li>
              ))}
            </ul>
          </li>
          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title"
                onClick={(e) => goToSomewhere(e, "/projects")}
                aria-label="Projects"
              >
                Projects
              </p>
            </button>
          </li>
          <li class="menu-category">
            <button
              class="accordion-menu"
              data-accordion-btn
              aria-expanded="false"
            >
              <p
                class="menu-title"
                onClick={(e) => goToSomewhere(e, "/contact")}
                aria-label="Contact us"
              >
                Contact
              </p>
            </button>
          </li>
        </ul>

        <div class="menu-bottom" style={{ marginBottom: "15px" }}>
          <ul class="menu-category-list">
            <li class="menu-category">
              <div className="" style={{ display: "flex", color: "#514c4c" }}>
                <div style={{ marginRight: "6px" }}>
                  <FaHeadphonesAlt />
                </div>
                <div style={{ marginTop: "2px" }} itemProp="telephone">
                  {companyData.phone}
                </div>
              </div>
            </li>
          </ul>
          <ul class="mobile-menu-category-list">
            <li class="menu-category">
              <button
                onClick={(e) => logOut(e)}
                class="menu-title align-self-start lh-1 btn px-2 py-2 d-flex align-items-center gap-2"
                aria-label={isLoggedIn ? "Logout" : "Login or register"}
              >
                {isLoggedIn ? (
                  <>
                    {" "}
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    Log Out
                  </>
                ) : (
                  <>
                    {" "}
                    <FontAwesomeIcon icon={faRightToBracket} />
                    Log In or Register
                  </>
                )}
              </button>
            </li>
          </ul>

          <ul class="menu-social-container">
            <li>
              <li>
                <a
                  href={`${companyData.facebook}`}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FiFacebook />
                </a>
              </li>
            </li>

            <li>
              <a
                href={`${companyData.tiktok}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok style={{ fontSize: "15px" }} />
              </a>
            </li>

            <li>
              <a
                href={`${companyData.instagram}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            </li>

            <li>
              <a
                href={`https://wa.me/+254${companyData.whatsapp}`}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <BsWhatsapp />
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header2;
